import { commentMutations } from "./comment";
import { feedbackMutations } from "./feedback";
import { mediaMutations } from "./media";
import { publicShowroomMutations } from "./publicShowroom";
import { showroomMutations } from "./showroom";
import { smallTeamMutations } from "./smallTeam";
import { sparkChatMutations } from "./sparkChat";
import { userMutations } from "./user";
import { workshopMutations } from "./workshop";

export const MUTATIONS = {
  ...userMutations,
  ...workshopMutations,
  ...publicShowroomMutations,
  ...smallTeamMutations,
  ...showroomMutations,
  ...commentMutations,
  ...mediaMutations,
  ...feedbackMutations,
  ...sparkChatMutations,
};
